import React, { useState } from "react";
import { Checkbox } from "antd";
function FilterType(props) {
  const [checked, setChecked] = useState([]);
  const EndowType=[
    {
      id: 1,
      nameVN: "phòng",
      nameENG: "room",
      code: "RM"
    },
    {
      id: 2,
      nameVN: "F&B",
      nameENG: "F&B",
      code: "FB"
    },
    {
      id: 3,
      nameVN: "dịch vụ khác",
      nameENG: "service other",
      code: "OT"
    }];
  const handleToggle = (value) => {
    const cuurentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (cuurentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(cuurentIndex, 1);
    }
    setChecked(newChecked);
    props.handlFilterCheck(newChecked);
  };
  return (
    <div className="formInput">
      <label>Chương trình</label>
      <div className="checkFilter">
        {EndowType &&
          EndowType.map((value, index) => {
            return (
              <div className="check" key={index}>
                <Checkbox
                  onChange={() => handleToggle(value.id)}
                  checked={checked.indexOf(value.id) === -1 ? false : true}
                >
                  {value.nameVN}
                </Checkbox>
              </div>
            );
          })}
      </div>
    </div>
  );
}
export default FilterType;
